/* import __COLOCATED_TEMPLATE__ from './standalone-message.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import type ChatMessage from 'embercom/models/operator/visual-builder/step/chat-message';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import type StepConfig from 'embercom/objects/visual-builder/configuration/step';
import type IntlService from 'ember-intl/services/intl';
import { inject as service } from '@ember/service';
import { INLINE_CONTROL_BLOCK_TYPES } from '@intercom/composer-ember/lib/config/composer-config';

export type ComposerTool = { name: string; options?: Record<string, unknown> };

const BASE_COMPOSER_TOOLS: ComposerTool[] = [
  { name: 'template-inserter' },
  { name: 'fallback-editor' },
  { name: 'text-formatter' },
];

export function composerToolsForHyperlinks(supportsHyperlinks: boolean): ComposerTool[] {
  let tools = [...BASE_COMPOSER_TOOLS];

  if (supportsHyperlinks) {
    tools.push({ name: 'anchor-editor', options: { showHelpLinkHeader: true } });
  }

  return tools;
}

export interface StandaloneMessageArgs {
  step: ChatMessage;
  readOnly: boolean;
  editorState: EditorState;
  stepConfig: StepConfig;
  onFocus?: any;
  hasWarning?: boolean;
}

interface Signature {
  Element: HTMLDivElement;
  Args: StandaloneMessageArgs;
}

export default class StandaloneMessagesNodeItem extends Component<Signature> {
  @service intl!: IntlService;

  get supportsHyperlinks(): boolean {
    return this.args.editorState.workflow?.editorConfig?.supportsHyperlinks ?? false;
  }

  get enabledComposerTools(): ComposerTool[] {
    return composerToolsForHyperlinks(this.supportsHyperlinks);
  }

  get hideFromTextFormatter() {
    return [INLINE_CONTROL_BLOCK_TYPES]; // This hides heading/subheading controls
  }

  get enabledInserterNames() {
    return ['emoji', 'gif', 'image'];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::StandaloneMessage': typeof StandaloneMessagesNodeItem;
  }
}
